import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import InputBox from '@/components/profile/inputBox'
import RoundBlueButton from '@/components/profile/roundBlueButton'
import { listOfSections } from "@/pages/profile/sections/basicDetails/constants"

import '@/pages/profile/sections/common.css'

export default function UserName(props: any) {
    const { profile } = useLocalTranslation();

    return (
        <div className='profileSectionOfSectionCommonMainCon'>
            <p className='commonH2'>
                {profile.fields.username}
                <span className='text-[#FF2828]'>*</span>
            </p>
            <p className='commonH3'>
                {profile.basicDetailsSection.notes.n3}
            </p>

            {props.errMsg !== "" &&
                <p className='commonErr1'>{props.errMsg}</p>
            }
            <InputBox
                id={listOfSections.username}
                onChange={(e: any) => props.handleInputChange(e, listOfSections.username)}
                value={props.value}
                placeholder={profile.placeHolders.enterYourUsername}
                showAsterisk={true}
            />

            <div className='commonBtnCon1'>
                <RoundBlueButton
                    disabled={props.isSubmitBtnLoading}
                    onClick={() => props.handleSubmit(listOfSections.username)}
                />
            </div>
        </div>
    );
}
